import AliasPasswordRenewal from "@/app/dto/AliasPasswordRenewal";

export default class InitPasswordRenewalRequest {
    type: string;
    alias: AliasPasswordRenewal;

    constructor(alias: string) {
        this.type = "ALIAS";
        this.alias = new AliasPasswordRenewal(alias);
    }
}
